import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { FaqsPageComponent } from './pages/faqs-page/faqs-page.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { ThankYouPageComponent } from './pages/thank-you-page/thank-you-page.component';
import { JobBoardPageComponent } from './pages/job-board-page/job-board-page.component';
import { SingleBlogPageComponent } from './pages/single-blog-page/single-blog-page.component';
import { ThanksQuotePageComponent } from './pages/thanks-quote-page/thanks-quote-page.component';
import { AdvisoryDirectoryPageComponent } from './pages/advisory-directory-page/advisory-directory-page.component';
import { ProjectsPageComponent } from './pages/projects-page/projects-page.component';
import { BannerProjectComponent } from './pages/banner-project/banner-project.component';
import { SingleProjectPageComponent } from './pages/single-project-page/single-project-page.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'faq', component: FaqsPageComponent },
  { path: 'blog', component: BlogPageComponent },
  // { path: 'cotizador', component: QuoterPageComponent },
  // { path: 'bolsa-de-trabajo', component: JobBoardPageComponent },
  { path: 'blog/:name/:id', component: SingleBlogPageComponent },
  { path: 'gracias/telefono', component: ThankYouPageComponent },
  { path: 'gracias/whatsapp', component: ThankYouPageComponent },
  { path: 'gracias/cotizacion', component: ThanksQuotePageComponent },
  // { path: 'directorio-asesores', component: AdvisoryDirectoryPageComponent },
  { path: 'banner', component: BannerProjectComponent },
  { path: 'proyectos', component: ProjectsPageComponent },
  { path: 'proyectos/:name/:id', component: SingleProjectPageComponent },

  // { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableViewTransitions: true, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
